import React from 'react';

import {HeadlineH1} from './text/Headlines';
import {RCol, Row} from './Grid';
import {ROLE_ADMIN, ROLE_EDITOR} from '../constants/userConstants';
import {TopBar, TopBarButton, TopBarLeftCol} from './form/FormElements';
import CEDownload from './CEDownload';
import EntityTable from './table/EntityTable';
import HideColumnModal from './table/HideColumnModal';
import config from '../config';
import windowTableConfig from './windowTableConfig';

export default class Windows extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      height: window.innerHeight,
      hiddenColumns: config.getHiddenColumns(),
    };
  }

  componentDidMount() {
    this._updateDimensions();
    window.addEventListener('resize', this._updateDimensions);
  }

  /**
   * Remove event listener
   */
  componentWillUnmount() {
    window.removeEventListener('resize', this._updateDimensions);
  }

  _updateDimensions = () => {
    this.setState({height: window.innerHeighHeight});
  };

  _updateHiddenColumns = hiddenColumns => {
    this.setState({hiddenColumns});
  };
  render() {
    const {data, user} = this.props;
    const config = windowTableConfig(user, window.innerHeight);
    const {hiddenColumns} = this.state;
    return (
      <div style={{maxWidth: '100%', overflow: 'hidden'}}>
        <TopBar>
          <Row>
            <TopBarLeftCol size={0.3} style={{paddingLeft: 100}}>
              <HeadlineH1>Fenster</HeadlineH1>
            </TopBarLeftCol>
            <RCol size={0.7}>
              {(user.role === ROLE_ADMIN || user.role === ROLE_EDITOR) && (
                <TopBarButton primary onClick={() => this.props.history.push('/new/window')} label="Neuer Eintrag" />
              )}
              <HideColumnModal columns={config.cols} callback={this._updateHiddenColumns} />
              <CEDownload />
              <TopBarButton onClick={() => this.props.history.push('/search')} label="Suche" />
            </RCol>
          </Row>
        </TopBar>
        <EntityTable
          tableConfig={config}
          data={data.allWindows}
          hiddenColumns={hiddenColumns}
          msg={'Noch keine Einträge erstellt'}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Windows.js